import PlateEditor from './PlateEditor';
import deserializeTinyMCE from './utils/deserializeTinyMCE';
import serializeAsHtml from './utils/serializeAsHtml';

export { deserializeTinyMCE, serializeAsHtml, PlateEditor };
